export default "__VITE_ASSET__D49$TQQO__"